import React from 'react'
import { FieldProps } from 'formik'
import { FormControlLabel, Checkbox } from '@material-ui/core'
import { CheckBoxOutlined } from '@material-ui/icons'
import styled from 'styled-components'

interface ICustomCheckboxFieldProps {
  placeholder?: string
  fieldValue: string
  label: string
  onChange?: (e) => {}
}

const StyledFormControlLabel = styled(FormControlLabel)`
  padding-left: 16px;
` as any

export const CustomCheckboxGroupField = ({
  field,
  form: { values, setFieldValue },
  fieldValue,
  ...props
}: FieldProps<any> & ICustomCheckboxFieldProps) => (
  <StyledFormControlLabel
    control={
      <Checkbox
        color="primary"
        {...field}
        {...props}
        value={fieldValue} // This fixed warning in console
        checked={field.value.some((value) => value === fieldValue)}
        checkedIcon={<CheckBoxOutlined />}
        onChange={(e) => {
          if (e.target.checked) {
            setFieldValue(field.name, [...field.value, fieldValue])
          } else {
            setFieldValue(
              field.name,
              field.value.filter((item) => item !== fieldValue)
            )
          }
          if (props.onChange) {
            props.onChange(e)
          }
        }}
      />
    }
    label={props.label}
  />
)
